<template>
  <li v-if="isAvailable">
    <span
      class="link d-block link__color--lg-lg link--naked cursor--not-allowed"
      :class="{ 'router-link-active': path === '' }"
      v-if="is_preview && !isTab"
    >
      {{ text }}
    </span>

    <router-link
      :to="to"
      custom
      v-slot="{ href, navigate, isActive }"
      v-else
    >
      <a
        class="link d-block link__color--lg-dg link--naked"
        :class="{ 'router-link-active': isTab ? isTabActive : isActive }"
        :href="href"
        @click="navigate"
      >
        {{ text }}
      </a>
    </router-link>
  </li>
</template>

<script setup>
import { computed, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from '@/vendors/i18n'
import { useRouter, useRoute } from 'vue-router'
import { useProjectStore } from '@/stores/ProjectStore'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { useQrcode } from '@/composables/modules/projects/useQrcode'
import Query from '@/classes/queries/Query'
import { get as _get, pick as _pick, isEqual as _isEqual } from 'lodash'

const { block } = defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { resolve } = useRouter()
const route = useRoute()
const { locale, translate } = useI18n()
const { getProject } = useProjectStore()
const { authUser } = storeToRefs(useAuthenticationStore())

const { project } = getProject({ id: route.params.projectSlug })
const { isQrcodeAvailable } = useQrcode({ project })

const is_preview = inject('preview', false)

const { projectSlug, templateId } = route.params

const path = _get(block.attributes, 'path')
const query = _get(block.attributes, 'query', {})

const text = computed(() => translate(block.getText('navigation')))
const isTab = computed(() => 'tab' in query)
const isTabActive = computed(() => _isEqual(query, _pick(route.query, Object.keys(query))) )
const q = computed(() => new Query({ query: { ...route.query, ...query } }).to_string)

const to = computed(() => {
  if (is_preview.value && Object.keys(query).length) return { name: 'Preview', params: { category: 'project', templateId }, query }

  return resolve(`/${locale}/project/${projectSlug}/${path}${q.value}`)
})

const isAvailable = computed(() => {
  if (path === 'qr-codes' && !isQrcodeAvailable.value && !is_preview.value) return false
  if (block.isShowed('only_project_members') && !project.value?.isAuthorized(authUser.value) && !is_preview.value) return false

  return block.isShowed('navigation') && !!text.value
})
</script>

<style lang="scss" scoped>
.link {
  padding: 12px;
  border-bottom: 2px solid transparent;
  margin: 0;
  white-space: nowrap;

  @include mq(sm) {
    border-width: 1px;
  }

  &.router-link-active {
    color: $dg;
    font-weight: bold;
    border-color: $color--primary;
  }
}
</style>